/** Draftهای مستقلِ ثبت فاکتور به ازای هر دسته */
const PREFIX = "gx-invoice-draft:";

export function draftKey(category) {
  return `${PREFIX}${category}`;
}

export function loadDraft(category) {
  if (!category) return null;
  try {
    const raw = localStorage.getItem(draftKey(category));
    if (!raw) return null;
    const d = JSON.parse(raw);
    if (!d || typeof d !== "object") return null;
    return d;
  } catch {
    return null;
  }
}

export function saveDraft(category, { values, eventType }) {
  if (!category) return;
  const payload = {
    values: values || {},
    eventType: eventType || null,
    updatedAt: new Date().toISOString(),
  };
  localStorage.setItem(draftKey(category), JSON.stringify(payload));
  return payload;
}

export function clearDraft(category) {
  if (!category) return;
  localStorage.removeItem(draftKey(category));
}

/** همهٔ draftهای دسته‌های فعال، جدیدترین اول */
export function listDrafts(categoryKeys = []) {
  const out = [];
  categoryKeys.forEach((key) => {
    const d = loadDraft(key);
    if (d) out.push({ category: key, ...d });
  });
  out.sort((a, b) => String(b.updatedAt || "").localeCompare(String(a.updatedAt || "")));
  return out;
}

export function latestDraft(categoryKeys = []) {
  const all = listDrafts(categoryKeys);
  return all[0] || null;
}
